import { useMemo, useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import {
  emptyHfCriteriaSelection,
  evaluateHfCriteria,
  FRAMINGHAM_HF_MAJOR_CRITERIA,
  FRAMINGHAM_HF_MINOR_CRITERIA,
} from "../../../utils/framinghamHfCriteria";

export default function FraminghamHFCriteriaComponent() {
  const [majorSelected, setMajorSelected] = useState(() =>
    emptyHfCriteriaSelection(FRAMINGHAM_HF_MAJOR_CRITERIA),
  );
  const [minorSelected, setMinorSelected] = useState(() =>
    emptyHfCriteriaSelection(FRAMINGHAM_HF_MINOR_CRITERIA),
  );

  const majorCount = useMemo(
    () => Object.values(majorSelected).filter(Boolean).length,
    [majorSelected],
  );
  const minorCount = useMemo(
    () => Object.values(minorSelected).filter(Boolean).length,
    [minorSelected],
  );
  const isPositive = evaluateHfCriteria(majorCount, minorCount);

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Box flex={1} overflow="auto" p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              <b>Major Criteria</b>: 2+ required for positive diagnosis (or 1,
              plus 2 minor)
            </Typography>
          </Grid>
          {FRAMINGHAM_HF_MAJOR_CRITERIA.map((criterion) => (
            <Grid item xs={12} key={criterion.code}>
              <FormControlLabel
                label={criterion.display}
                control={
                  <Checkbox
                    checked={majorSelected[criterion.code]}
                    onChange={(e) =>
                      setMajorSelected({
                        ...majorSelected,
                        [criterion.code]: e.target.checked,
                      })
                    }
                  />
                }
              />
            </Grid>
          ))}

          <Grid item xs={12} mt={2}>
            <Typography>
              <b>Minor Criteria</b>: used with 1 major (need 2+ minor)
            </Typography>
          </Grid>
          {FRAMINGHAM_HF_MINOR_CRITERIA.map((criterion) => (
            <Grid item xs={12} key={criterion.code}>
              <FormControlLabel
                label={criterion.display}
                control={
                  <Checkbox
                    checked={minorSelected[criterion.code]}
                    onChange={(e) =>
                      setMinorSelected({
                        ...minorSelected,
                        [criterion.code]: e.target.checked,
                      })
                    }
                  />
                }
              />
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box
        p={2}
        sx={{
          borderTop: 1,
          borderColor: "#D3D3D3",
        }}
      >
        <Typography variant="h5">Result</Typography>
        <Typography>
          {isPositive ? "Positive" : "Negative"} (major {majorCount}, minor{" "}
          {minorCount})
        </Typography>
      </Box>
    </Box>
  );
}
